import React, { Component } from 'react';
import { Button, Card, Col, Container, Form, InputGroup, Row } from 'react-bootstrap';
import { Fetcher } from '../../Helpers/fetcher.js';
import { Notify } from '../../Helpers/notification.js';

import "./index.css";
class UpdatePwd extends Component {
	constructor(props) {
		super(props);
		this.state = {
			password: '',
			confirmPassword: '',
			apiPath: this.props.app.apiPath,
			token: this.props.selectedToken
		}
	}

	setvalue = (e) => {
		this.setState({
			[e.target.name]: e.target.value,
		});
	}

	updatePwd = (e) => {
		e.preventDefault();
		const password = this.state.password;
		const token = this.state.token;
		const confirmPassword = this.state.confirmPassword;
		if (this.state.confirmPassword !== this.state.password) {
			Notify.notify('Password & Confim Password don\'t match');
			return;
		}
		else if (password === '') {
			Notify.notify('Please enter passowrd');
		} 
		else if (confirmPassword === '') {
			Notify.notify('Please enter Confirm Passowrd');
		}
		else {
			const data = {
				password: password,
				token: token
			}
			return Fetcher.post(this.props.app.apiPath + '/api/voicemail/update/pwd', { headers: { "Content-type": "application/json" }, method: 'POST', body: JSON.stringify(data) })
				.then(res => {
					if (res.message === 'Parameters Incorrect') {
						Notify.notify('Password Reset Failed');
					} else if(res.message === 'Password Reset Successfully'){
						Notify.notify(res.message);
						window.location.href='/login';
					}
					else {
						Notify.notify('Password Reset Failed');
					}
				})
				.catch(err => {
					console.log('Error in UpdatePwd', err);
				});

		}
	}

	setMessageShow = (status) => {
		this.setState({
		});
	}


	render() {
		return (
			<div className="app flex-row align-items-center">
				<Container>
					<Row className="justify-content-center">
						<Col md="4">
							<Card className="p-4">
								<Card.Body>
									<Form method="post" onSubmit={this.updatePwd}>
										<div className="UpdatePwd-logo text-center">
											{this.props.app.logo && <img className="navbar-brand-full" src={this.props.app.logo} alt="CoreUI Logo" />}
										</div>

										<p className="text-muted text-center">Update Password</p>
										<InputGroup className="mb-3">
											<Form.Control className="field-password" name="password" type="password" placeholder="Password" onChange={e => this.setvalue(e)} value={this.state.password} autoComplete="username" />
										</InputGroup>

										<InputGroup className="mb-3">
											
											<Form.Control className="field-password" name="confirmPassword" type="password" placeholder="Confirm Password" onChange={e => this.setvalue(e)} value={this.state.confirmPassword} autoComplete="username" />
										</InputGroup>
										
										<Row>
											<Col xs="4">
												<Button type="submit" color="primary" className="px-4 btn btn-primary btn-round">Update</Button>
											</Col>
										</Row>
									</Form>
								</Card.Body>
							</Card>
						</Col>
					</Row>
				</Container>

			</div>
		);
	}
}

export default UpdatePwd;